window.addEventListener('DOMContentLoaded', function () {
    /*
     * Sticky head - remove shadow and add back when scrolled
     */
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
            $(".site-header").removeClass("no-drop-shadow");
        }
        else {
            $(".site-header").addClass("no-drop-shadow");
        }
    });

    /* Fix - Scroll up issue on subcription page */
    $(".subscription-center-page button.btn-submit").on('click', function (event) {
        $('.subscription-center-page .js-form .InvestorType').find('option').each(function () {
            if ($(this).val() === "" && $(this).attr('selected') === "selected") {
                window.setTimeout(function () {
                    $("html, body").animate({
                        scrollTop: $(".subscribe-block").offset().top - 100
                    }, 0)
                }, 50)
            }
        });
    });

    //Smooth scrolling effect for the hyperlinks
    $('main a[href^="#"], section a[href^="#"], header.header-new a[href^="#"]').click(function () {
        if ($(this).attr('href') == "#") return false; //don't animate if it is not pointing to anything legit.
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - 110
        }, 500);
        return false;
    });

    /**
     * Mega-menu event handler to prevent being overridden by a dropdown.
     */
    $("li.site-header__nav-item.nav-item").hover(function () {
        $(".dropdown-menu.show").removeClass("show");
        $(".dropdown.show, .dropdown-checkbox.show").removeClass("show")
    });
})

function updatePageVistCountOnLocalStorage() {
    var pageVisitCount = localStorage.getItem("ve-PageVisitCount-eu");
    if (pageVisitCount) {
        pageVisitCount = parseInt(pageVisitCount) + 1;
    } else {
        //if gateway modal is open, ignore the page visit
        const gatewayModal = document.getElementById("gateway-modal");
        if(gatewayModal && gatewayModal.classList.contains("show")) return;
        pageVisitCount = 1;
    }

    var pageVisitsTracked = localStorage.getItem("ve-pagevisits-eu");
    if(!pageVisitsTracked){
        pageVisitCount = 1;
    }
    localStorage.setItem("ve-PageVisitCount-eu", pageVisitCount);
}

window.addEventListener("DOMContentLoaded", updatePageVistCountOnLocalStorage);

/*
* Sticky back-to-top
*/
window.stickyBackToTop = {
    init: function () {

        if ($('#back-to-top-wrapper > .back-to-top').length === 0) return;

        var $btt = $('#back-to-top-wrapper > .back-to-top');
        var $win = $(window);
        var height = $win.height() / 4;

        $win.scroll(function (e) {
            $win.scrollTop() > height ? $btt.show() : $btt.hide();
        });

    }
}
window.addEventListener('DOMContentLoaded', function () {
    stickyBackToTop.init();
});

//
/*** Menu and AHP-related code ***/
/*** These are a duplicate of static/js/header/header-override.js
 *      Make sure they are modified there too! ***/

/*** converts a bs4 tab-nav to render on hover vs click ***/
hoverfytabs = function (selector, hoverblock) {
    hoverblock = (!hoverblock) ? false : hoverblock;

    $(selector).hover(function () {
        if ($(this).hasClass('hoverblock'))
            return;
        else
            /*force remove everything else*/
            targettedTabGroup = $(this).parent().find('a.active').data('target')
        $(targettedTabGroup).parent().find('.active.show').removeClass('active').removeClass('show')
        $(this).parent().find('a').removeClass('active').removeClass('show')
        $(this).find('a').tab('show');
    });
    if (hoverblock === true) {
        $(selector).find('a').click(function () {
            $(this).parent()
                .siblings().addClass('hoverblock');
        });

    }

}

//focus on searchbox once the user clicks search. Must test.
focusOnSearchBox = function () {
    $('#site-header-search').on('shown.bs.modal', function (e) {
        $('input.search__input').focus();
    })
}

$(function () {
    focusOnSearchBox();

    /* Adds a class to the dynamic modal backdrop so we can style it as needed. */
    var SearchBackdropClass = "bs4-search-backdrop";
    $("#site-header-search").on('shown.bs.modal', function () {
        $('.modal-backdrop').addClass(SearchBackdropClass);
    }).on('hidden.bs.modal', function () { $('.modal-backdrop').addClass(SearchBackdropClass); });

    /* Navigates to the search page once you press enter on the search bar. */
    $(".form-control.search__input").keyup(function (e) {
        if (e.which == 13) {
            window.location.href = window["sharedData"].SearchFormatString.replace("{0}", encodeURIComponent(e.currentTarget.value));
        }
    })

    /**
     * Remove and replace all of the submen items to remove all eventlistners added by VShift.
     * This is replaced by our own hover function below.
     * Done so we can keep their scripts.js file intact.
     */
    $('.site-header__submenu-action').each(function (i, e) {
        var elClone = e.cloneNode(true);
        e.parentNode.replaceChild(elClone, e);
    });

    /** Non-investment submenu items --> make sure they are activated on hover. */
    $('.site-header__submenu .site-header__submenu-action.list-group-item').hover(function (e) {
        //get the data values
        var menu = $(this).data('menu');
        var targetPane = $(this).data('default');

        //make this active
        $('.site-header__submenu#' + menu + ' .site-header__submenu-action.list-group-item').removeClass('active').removeClass('show');
        $(this).tab('show').addClass('active show');

        //Toggle the actual menu now
        $('#' + menu).find(".tab-content > .tab-pane").removeClass("active show");
        $('#' + menu).find("#" + targetPane).addClass("active show");

    });

    //Convert the megamenu tabs in the investments section to work as tab on hover.
    hoverfytabs('.navbar .hover-tabs > .nav-tabs > li', false);
    //hoverfytabs('.bs4-nav .site-header__submenu-inner .list-group', false);

});